function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function Svg1928(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    height: "100%",
    width: "100%",
    viewBox: "0 0 700 700",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("g", {
    key: 0,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 0,
    y: 0,
    width: 10.53,
    height: 1.35,
    style: {
      fill: "#4C0000"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "white",
      fontSize: 0.225
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 5.265,
    y: 0.675
  }, "\n        Alpine\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 1,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 0,
    y: 1.35,
    width: 10.53,
    height: 9.22,
    style: {
      fill: "#FF7F7F"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "white",
      fontSize: 2.305
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 5.265,
    y: 5.960000000000001
  }, "\n        Mono\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 2,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 0,
    y: 10.56,
    width: 10.53,
    height: 22.96,
    style: {
      fill: "#FFD4D4"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "black",
      fontSize: 1.755
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 5.265,
    y: 22.04
  }, "\n        Sierra\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 3,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 0,
    y: 33.53,
    width: 10.53,
    height: 23.69,
    style: {
      fill: "#FFD4D4"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "black",
      fontSize: 1.5042857142857142
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 5.265,
    y: 45.375
  }, "\n        Trinity\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 4,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 0,
    y: 57.21,
    width: 10.53,
    height: 30.86,
    style: {
      fill: "#FFB2B2"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "black",
      fontSize: 1.31625
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 5.265,
    y: 72.64
  }, "\n        Mariposa\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 5,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 0,
    y: 88.07,
    width: 10.53,
    height: 35.73,
    style: {
      fill: "#FFB2B2"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "black",
      fontSize: 1.17
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 5.265,
    y: 105.93499999999999
  }, "\n        Del_Norte\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 6,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 0,
    y: 123.8,
    width: 10.53,
    height: 42.97,
    style: {
      fill: "#FFB2B2"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "black",
      fontSize: 2.106
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 5.265,
    y: 145.285
  }, "\n        Modoc\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 7,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 0,
    y: 166.77,
    width: 10.53,
    height: 53.72,
    style: {
      fill: "#C5E1FF"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "black",
      fontSize: 1.755
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 5.265,
    y: 193.63
  }, "\n        Plumas\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 8,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 0,
    y: 220.49,
    width: 10.53,
    height: 54.42,
    style: {
      fill: "#FFB2B2"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "black",
      fontSize: 2.6325
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 5.265,
    y: 247.70000000000002
  }, "\n        Inyo\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 9,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 0,
    y: 274.91,
    width: 10.53,
    height: 58.09,
    style: {
      fill: "#ABD3FF"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "black",
      fontSize: 1.755
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 5.265,
    y: 303.95500000000004
  }, "\n        Amador\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 10,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 0,
    y: 333,
    width: 10.53,
    height: 60.73,
    style: {
      fill: "#FFD4D4"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "black",
      fontSize: 1.17
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 5.265,
    y: 363.365
  }, "\n        Calaveras\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 11,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 0,
    y: 393.74,
    width: 10.53,
    height: 71.84,
    style: {
      fill: "#ABD3FF"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "black",
      fontSize: 1.17
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 5.265,
    y: 429.66
  }, "\n        El_Dorado\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 12,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 0,
    y: 465.58,
    width: 10.53,
    height: 72.07,
    style: {
      fill: "#FF4C4C"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "white",
      fontSize: 2.6325
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 5.265,
    y: 501.615
  }, "\n        Lake\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 13,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 0,
    y: 537.65,
    width: 10.53,
    height: 80.57,
    style: {
      fill: "#FFB2B2"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "black",
      fontSize: 1.755
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 5.265,
    y: 577.935
  }, "\n        Colusa\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 14,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 0,
    y: 618.22,
    width: 10.53,
    height: 81.78,
    style: {
      fill: "#FFB2B2"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "black",
      fontSize: 1.31625
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 5.265,
    y: 659.11
  }, "\n        Tuolumne\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 15,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 10.53,
    y: 0,
    width: 24.36,
    height: 37.48,
    style: {
      fill: "#FFB2B2"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "black",
      fontSize: 2.436
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 22.71,
    y: 18.74
  }, "\n        San_Benito\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 16,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 34.89,
    y: 0,
    width: 27.07,
    height: 37.48,
    style: {
      fill: "#FFB2B2"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "black",
      fontSize: 4.511666666666667
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 48.425,
    y: 18.74
  }, "\n        Lassen\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 17,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 61.97,
    y: 0,
    width: 27.59,
    height: 37.48,
    style: {
      fill: "#FF4C4C"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "white",
      fontSize: 5.518
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 75.765,
    y: 18.74
  }, "\n        Glenn\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 18,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 89.56,
    y: 0,
    width: 29.41,
    height: 37.48,
    style: {
      fill: "#FFD4D4"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "black",
      fontSize: 7.3525
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 104.265,
    y: 18.74
  }, "\n        Yuba\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 19,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 118.97,
    y: 0,
    width: 30.18,
    height: 37.48,
    style: {
      fill: "#FFD4D4"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "black",
      fontSize: 5.03
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 134.06,
    y: 18.74
  }, "\n        Sutter\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 20,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 149.15,
    y: 0,
    width: 30.41,
    height: 37.48,
    style: {
      fill: "#FFD4D4"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "black",
      fontSize: 5.068333333333333
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 164.35500000000002,
    y: 18.74
  }, "\n        Nevada\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 21,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 179.55,
    y: 0,
    width: 31.21,
    height: 37.48,
    style: {
      fill: "#FFB2B2"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "black",
      fontSize: 5.201666666666667
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 195.155,
    y: 18.74
  }, "\n        Madera\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 22,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 210.76,
    y: 0,
    width: 32.07,
    height: 37.48,
    style: {
      fill: "#FFD4D4"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "black",
      fontSize: 5.345
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 226.795,
    y: 18.74
  }, "\n        Shasta\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 23,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 242.83,
    y: 0,
    width: 37.65,
    height: 37.48,
    style: {
      fill: "#FF4C4C"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "white",
      fontSize: 6.246666666666666
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 261.65500000000003,
    y: 18.74
  }, "\n        Tehama\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 24,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 280.48,
    y: 0,
    width: 41.63,
    height: 37.48,
    style: {
      fill: "#FFD4D4"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "black",
      fontSize: 7.4959999999999996
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 301.295,
    y: 18.74
  }, "\n        Kings\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 25,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 322.1,
    y: 0,
    width: 45.28,
    height: 37.48,
    style: {
      fill: "#FFB2B2"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "black",
      fontSize: 9.37
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 344.74,
    y: 18.74
  }, "\n        Yolo\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 26,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 367.39,
    y: 0,
    width: 49.27,
    height: 37.48,
    style: {
      fill: "#FFB2B2"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "black",
      fontSize: 4.685
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 392.025,
    y: 18.74
  }, "\n        Siskiyou\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 27,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 416.66,
    y: 0,
    width: 54.2,
    height: 37.48,
    style: {
      fill: "#C5E1FF"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "black",
      fontSize: 6.246666666666666
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 443.76000000000005,
    y: 18.74
  }, "\n        Placer\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 28,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 470.86,
    y: 0,
    width: 55.21,
    height: 37.48,
    style: {
      fill: "#FF7F7F"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "white",
      fontSize: 4.164444444444444
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 498.46500000000003,
    y: 18.74
  }, "\n        Mendocino\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 29,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 526.07,
    y: 0,
    width: 56.15,
    height: 37.48,
    style: {
      fill: "#FF7F7F"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "white",
      fontSize: 6.246666666666666
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 554.1450000000001,
    y: 18.74
  }, "\n        Merced\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 30,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 582.23,
    y: 0,
    width: 58.29,
    height: 37.48,
    style: {
      fill: "#FF4C4C"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "white",
      fontSize: 4.685
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 611.375,
    y: 18.74
  }, "\n        Imperial\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 31,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 640.52,
    y: 0,
    width: 59.48,
    height: 37.48,
    style: {
      fill: "#FFB2B2"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "black",
      fontSize: 9.37
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 670.26,
    y: 18.74
  }, "\n        Napa\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 32,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 10.53,
    y: 37.48,
    width: 60.83,
    height: 39.99,
    style: {
      fill: "#FF7F7F"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "white",
      fontSize: 2.666
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 40.945,
    y: 57.474999999999994
  }, "\n        San_Luis_Obispo\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 33,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 10.53,
    y: 77.47,
    width: 60.83,
    height: 46.77,
    style: {
      fill: "#FF7F7F"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "white",
      fontSize: 9.354000000000001
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 40.945,
    y: 100.855
  }, "\n        Butte\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 34,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 10.53,
    y: 124.24,
    width: 60.83,
    height: 51.34,
    style: {
      fill: "#FF7F7F"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "white",
      fontSize: 6.4175
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 40.945,
    y: 149.91
  }, "\n        Monterey\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 35,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 10.53,
    y: 175.58,
    width: 60.83,
    height: 54.13,
    style: {
      fill: "#FF4C4C"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "white",
      fontSize: 5.413
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 40.945,
    y: 202.645
  }, "\n        Santa_Cruz\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 36,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 10.53,
    y: 229.72,
    width: 60.83,
    height: 57.61,
    style: {
      fill: "#FF0000"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "white",
      fontSize: 8.23
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 40.945,
    y: 258.525
  }, "\n        Ventura\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 37,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 10.53,
    y: 287.33,
    width: 60.83,
    height: 58.89,
    style: {
      fill: "#FF0000"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "white",
      fontSize: 7.36125
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 40.945,
    y: 316.775
  }, "\n        Humboldt\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 38,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 10.53,
    y: 346.22,
    width: 60.83,
    height: 60.51,
    style: {
      fill: "#FFD4D4"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "black",
      fontSize: 10.084999999999999
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 40.945,
    y: 376.475
  }, "\n        Solano\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 39,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 10.53,
    y: 406.73,
    width: 60.83,
    height: 61.37,
    style: {
      fill: "#FFB2B2"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "black",
      fontSize: 12.166
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 40.945,
    y: 437.415
  }, "\n        Marin\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 40,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 10.53,
    y: 468.09,
    width: 60.83,
    height: 71.82,
    style: {
      fill: "#FF4C4C"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "white",
      fontSize: 6.083
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 40.945,
    y: 504
  }, "\n        Stanislaus\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 41,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 10.53,
    y: 539.91,
    width: 60.83,
    height: 75.31,
    style: {
      fill: "#FF4C4C"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "white",
      fontSize: 4.679230769230769
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 40.945,
    y: 577.5649999999999
  }, "\n        Santa_Barbara\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 42,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 10.53,
    y: 615.22,
    width: 60.83,
    height: 84.78,
    style: {
      fill: "#FF7F7F"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "white",
      fontSize: 10.138333333333334
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 40.945,
    y: 657.61
  }, "\n        Tulare\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 43,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 71.37,
    y: 37.48,
    width: 62.17,
    height: 94.71,
    style: {
      fill: "#FF7F7F"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "white",
      fontSize: 10.361666666666666
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 102.45500000000001,
    y: 84.835
  }, "\n        Sonoma\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 44,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 133.54,
    y: 37.48,
    width: 64.36,
    height: 94.71,
    style: {
      fill: "#FF7F7F"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "white",
      fontSize: 5.363333333333333
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 165.72,
    y: 84.835
  }, "\n        Contra_Costa\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 45,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 197.9,
    y: 37.48,
    width: 65.02,
    height: 94.71,
    style: {
      fill: "#B20000"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "white",
      fontSize: 7.224444444444444
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 230.41,
    y: 84.835
  }, "\n        Riverside\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 46,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 262.92,
    y: 37.48,
    width: 67.51,
    height: 94.71,
    style: {
      fill: "#FF7F7F"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "white",
      fontSize: 16.8775
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 296.675,
    y: 84.835
  }, "\n        Kern\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 47,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 330.43,
    y: 37.48,
    width: 70.24,
    height: 94.71,
    style: {
      fill: "#FFB2B2"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "black",
      fontSize: 7.804444444444444
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 365.55,
    y: 84.835
  }, "\n        San_Mateo\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 48,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 400.67,
    y: 37.48,
    width: 78.69,
    height: 94.71,
    style: {
      fill: "#FF7F7F"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "white",
      fontSize: 7.153636363636363
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 440.015,
    y: 84.835
  }, "\n        San_Joaquin\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 49,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 479.35,
    y: 37.48,
    width: 109.71,
    height: 94.71,
    style: {
      fill: "#FFD4D4"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "black",
      fontSize: 15.784999999999998
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 534.205,
    y: 84.835
  }, "\n        Fresno\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 50,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 589.06,
    y: 37.48,
    width: 110.94,
    height: 94.71,
    style: {
      fill: "#B20000"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "white",
      fontSize: 15.784999999999998
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 644.53,
    y: 84.835
  }, "\n        Orange\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 51,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 71.37,
    y: 132.2,
    width: 96.45,
    height: 110.59,
    style: {
      fill: "#B20000"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "white",
      fontSize: 6.889285714285714
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 119.595,
    y: 187.495
  }, "\n        San_Bernardino\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 52,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 71.37,
    y: 242.79,
    width: 96.45,
    height: 115.51,
    style: {
      fill: "#FFD4D4"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "black",
      fontSize: 9.645
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 119.595,
    y: 300.545
  }, "\n        Sacramento\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 53,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 71.37,
    y: 358.3,
    width: 96.45,
    height: 140.52,
    style: {
      fill: "#FF7F7F"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "white",
      fontSize: 8.768181818181818
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 119.595,
    y: 428.56
  }, "\n        Santa_Clara\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 54,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 71.37,
    y: 498.81,
    width: 96.45,
    height: 201.19,
    style: {
      fill: "#FF4C4C"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "white",
      fontSize: 10.716666666666667
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 119.595,
    y: 599.405
  }, "\n        San_Diego\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 55,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 167.82,
    y: 132.2,
    width: 256.01,
    height: 193.03,
    style: {
      fill: "#FF4C4C"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "white",
      fontSize: 27.575714285714287
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 295.825,
    y: 228.71499999999997
  }, "\n        Alameda\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 56,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 423.83,
    y: 132.2,
    width: 276.17,
    height: 193.03,
    style: {
      fill: "#C5E1FF"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "black",
      fontSize: 14.848461538461539
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 561.915,
    y: 228.71499999999997
  }, "\n        San_Francisco\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 57,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 167.82,
    y: 325.23,
    width: 532.18,
    height: 374.77,
    style: {
      fill: "#FF0000"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "white",
      fontSize: 34.07
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 433.90999999999997,
    y: 512.615
  }, "\n        Los_Angeles\n      ")));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(Svg1928);
export default __webpack_public_path__ + "static/media/1928.1440cc2fe213842104cbf06a965de3a7.svg";
export { ForwardRef as ReactComponent };